module.exports = __webpack_public_path__ + "static/fun-icon1-dcc650becbc2d5bebfbc6f28d58d6bb1.png";